export default {
  statistics: {
    total_followers: 'Totaal volgers',
    emails_sent: 'Verzonden e-mails',
    emails_opened: 'Geopende e-mails',
    emails_clicked: 'Geklikt op e-mails',
    emails_average_open_rate: 'E-mailopenratio',
    emails_average_click_rate: 'E-mailklikratio',
    push_notifications_sent: 'Verzonden pushmeldingen',
    push_notifications_clicked: 'Geklikt op pushmeldingen',
  },
};
